module.exports = __webpack_public_path__ + "67c6f3ec5c7b5c134197141f7fdaaf20.jpg";